<template>
  <div class="flex">
    <el-input v-model="uploadValue" type="text" clearable />
    <el-upload
      v-loading="loading"
      :action="action"
      :multiple="false"
      :limit="1"
      :with-credentials="true"
      :before-upload="onBefore"
      :on-change="submitUpload"
      :on-remove="handleRemove"
      :file-list="fileList"
      :on-error="onError"
      :on-success="onSuccess"
      ref="upload"
      name="upload"
      @click.native="onAttach"
    >
      <el-button
        slot="trigger"
        size="small"
        type="primary"
        :disabled="!!fileList.length"
        >Выберите файл</el-button
      >
      <!-- <div v-if="!loading && uploadValue[0].response.path">
      <el-input v-model="uploadValue[0].response.path" type="text" />
      <el-button
        v-if="!fileList.length"
        type="danger"
        icon="el-icon-delete"
        circle
        @click="uploadValue = ''"
      />
    </div> -->
      <i v-if="error">{{ error }}</i>
    </el-upload>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: [File, Array, String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      fileList: [],
      error: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["mediaUrl"]),
    action() {
      const baseApi = process.env.VUE_APP_BASE_API
        ? process.env.VUE_APP_BASE_API
        : "";
      return `${baseApi}/api/admin/hosting/files/`;
    },
    uploadValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (val[0] && val[0].response && val[0].response.path) {
          this.$emit("input", val[0].response.path);
        } else {
          this.$emit("input", val);
        }
      },
    },
  },
  watch: {
    // если форму сбросили, удаляем прикрепленные файлы
    value(newVal) {
      if (!newVal) {
        this.fileList = [];
      }
    },
  },
  methods: {
    submitUpload(file, fileList) {
      this.fileList = fileList;
      this.uploadValue = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.uploadValue = null;
    },
    onAttach(e) {
      if (this.fileList.length) {
        e.preventDefault();
      }
    },
    onBefore() {
      this.loading = true;
    },
    onSuccess(res) {
      this.loading = false;
      this.$emit("input", res);
      this.$nextTick(() => {
        this.$refs.upload.clearFiles();
        this.fileList = [];
      });
    },
    onError() {
      this.loading = false;
      this.$emit("input", null);
      this.error = "Ошибка";
      this.$message({
        type: "error",
        message: "Ошибка при загрузке.",
      });
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
.flex div:nth-child(1) {
  margin-right: 20px;
}
.flex .el-upload-list {
  display: none;
}
</style>
